import { render, staticRenderFns } from "./ItemLanguage.vue?vue&type=template&id=daf581bc&scoped=true"
import script from "./ItemLanguage.vue?vue&type=script&lang=js"
export * from "./ItemLanguage.vue?vue&type=script&lang=js"
import style0 from "./ItemLanguage.vue?vue&type=style&index=0&id=daf581bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf581bc",
  null
  
)

export default component.exports